import React from 'react'
import i18n from 'simple-react-i18n'
import Icon from '../../components/icon/Icon'

const getEventTypeBalise = (icon, label) => {
    return <h6 className='valign-wrapper'><Icon size='small' icon={icon} /> {label}</h6>
}

const getEventType = ({ eventType }) => {
    switch (eventType) {
        case 'M':
            return getEventTypeBalise('build', i18n.curative)
        case 'G':
            return getEventTypeBalise('directions_run', i18n.preventive)
        case 'P':
            return getEventTypeBalise('event_note', i18n.toPlan)
        case 'S':
            return getEventTypeBalise('visibility', i18n.toMonitor)
        case 'C':
            return getEventTypeBalise('comment', i18n.comment)
        case 'T':
            return getEventTypeBalise('build', i18n.technique)
        case 'N':
            return getEventTypeBalise('event_busy', i18n.notDoneIntervention)
        default:
            return getEventTypeBalise('more_horiz', i18n.undefinedIntervention)
    }
}

const getEventTypeInfo = () => {
    return {
        M: { icon: 'build', label: i18n.curative },
        G: { icon: 'directions_run', label: i18n.preventive },
        P: { icon: 'event_note', label: i18n.toPlan },
        S: { icon: 'visibility', label: i18n.toMonitor },
        C: { icon: 'comment', label: i18n.comment },
        T: { icon: 'build', label: i18n.technique },
        N: { icon: 'event_busy', label: i18n.notDoneIntervention },
        // default: { icon: 'more_horiz', label: i18n.undefinedIntervention }
    }
}

const COLOR_BY_TYPE = {
    T: '#7B241C',
    M: 'red',
    S: 'orange',
    G: 'blue',
    P: 'yellow',
    C: '#006400',
    N: 'black',
}

const getColor = eventTypeId => {
    switch (eventTypeId) {
        case 'c':
            return 'GREEN'
        case 'u':
            return 'ORANGE'
        case 'v':
            return 'BLUE'
        case 'd':
            return 'RED'
        default:
            return 'GREY'
    }
}

const getExploitationEventsTypes = () => [{
    code: 'c',
    id: 1,
    label: i18n.added,
    color: getColor('c'),
    icon: 'add_box',
}, {
    code: 'u',
    id: 2,
    label: i18n.modification,
    color: getColor('u'),
    icon: 'edit',
}, {
    code: 'd',
    id: 3,
    label: i18n.deleting,
    color: getColor('d'),
    icon: 'delete',
}, {
    code: 'v',
    id: 4,
    label: i18n.validation,
    color: getColor('v'),
    icon: 'delete',
}]

export { getEventType, getEventTypeInfo, COLOR_BY_TYPE, getColor, getExploitationEventsTypes }
